<div class="input-group d-flex">
    <input id="identifierInputField" name="identifierInputField" placeholder="{{placeholder}}"
           [class.text-uppercase]="uppercase"
           [(ngModel)]="inputValue" [disabled]="editDisabled" [maxlength]="maxlength" [readonly]="readonly"
           autocomplete="off" required/>

    <div class="input-group-append d-flex" *ngIf="!readonly">
        <button type="button" class="suffix-button" [disabled]="!isOtpButtonEnabled()"
                (click)="onSendOtpButtonClick()">{{getOtpButtonLabel()}}
        </button>
    </div>
</div>
